<div *ngIf="isLoading()" class="fixed inset-0 w-screen h-screen bg-gray-300 bg-opacity-70 flex items-center justify-center z-[9999]" id="loader">
    <div class="flex flex-col items-center gap-4">
      <div class="w-10 aspect-square rounded-full border-3 border-gray-300 border-r-primary animate-spin-slow"></div>  
      <div *ngIf="loadingMessage()" class="text-center">
        <p class="text-lg font-semibold text-gray-800">{{ loadingMessage() }}</p>
      </div>
    </div>
</div>

